import { render, staticRenderFns } from "./PlantConfigurationNotificationSubscribers.vue?vue&type=template&id=2f59d9d6&"
import script from "./PlantConfigurationNotificationSubscribers.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationNotificationSubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VContainer,VFlex,VLayout})
